import React , {useEffect} from "react";
import * as s from './Documents.style';
//reducers
import * as actions from "../../../store/actions/index";
import { useDispatch , useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import DocumentsControls from '../documents/documentsControls/DocumentsControls';
import Spinner from "../../../components/shared/spinner/Spinner";
const Documents = () => {
  let userId = useSelector((state) => state.auth.userId)
 
  let history = useHistory();
  let dispatch = useDispatch();
  let folders = useSelector((state) => state.userFolders.folders)
  let count = useSelector((state) => state.userFolders.count);
  console.log(count)
  let foldersLoading = useSelector((state) => state.userFolders.loading)
  useEffect(() => {
    dispatch(actions.fetchFolders())
  } , [])



  

  
  return (
   
    <s.MainContainer>
      <s.HeaderContainer>
          <s.H1>MY DOCUMENTS</s.H1>
          <s.btnContainer>
      <s.CreateBtn 
       onClick={() =>
        history.push(`/documents/${userId}/folder-profile`)
      }>
             Create Folder
        </s.CreateBtn>
      </s.btnContainer>
      </s.HeaderContainer>
      {foldersLoading === false ? (
        <s.FolderContainer>
        <DocumentsControls foldersData = {folders} />
      </s.FolderContainer>
   

      ):(
        <s.SpinnerContainer>
        <Spinner />
      </s.SpinnerContainer>
      )}
        

    </s.MainContainer>
  
  );
};

export default Documents;
